export const DATASHEET_DIVIDER_TOKEN = '#='

export const dsSplit = (value: string): string[] =>
  value.split(DATASHEET_DIVIDER_TOKEN, 2)